import { useMemo } from "react";
import { Cell } from "react-table";
import { Box } from "@chakra-ui/layout";
import { formatCurrency, } from "@brazilian-utils/brazilian-utils";

import { AcordoContaItem, ParcelasAcordoType } from "core/features/acordo/typings";
import moment from "moment";

interface CellItemAccordion extends Cell<AcordoContaItem> { }

export function useAccordionColumns() {
    return useMemo(() => {
        return [
            {
                Header: "Cód.",
                accessor: "status",
                Cell: ({ row: { index } }: CellItemAccordion) => (
                    <Box>{index + 1}</Box>
                ),
            },
            {
                Header: "Dívida",
                accessor: "valor",
                Cell: ({ row: { original } }: CellItemAccordion) => (
                    <Box>R$ {formatCurrency(original.valor ? original.valor : 0)}</Box>
                ),
            },
            {
                Header: "Pago",
                accessor: "valorPago",
                Cell: ({ row: { original } }: CellItemAccordion) => (
                    <Box>
                        R$ {formatCurrency(original.valorPago ? original.valorPago : 0)}
                    </Box>
                ),
            },
            {
                Header: "Abertura",
                accessor: "createdAt",
                Cell: ({ row: { original } }: CellItemAccordion) => (
                    <Box> {moment(original.createdAt).format("DD/MM/YYYY")} </Box>
                ),
            },
            {
                Header: "Cancelamento",
                accessor: "dataCancelamento",
                Cell: ({ row: { original } }: CellItemAccordion) => (
                    <Box>
                        {original.dataCancelamento && moment(original.dataCancelamento).format("DD/MM/YYYY")}
                    </Box>
                ),
            },
        ];
    }, []);
}

// ***** ///

interface CellItemAccordionInner extends Cell<ParcelasAcordoType> { }

export function useAccordionInnerColumns() {
    return useMemo(() => {
        return [
            {
                Header: "Parcela",
                accessor: "parcela",
                Cell: ({ row: { index } }: CellItemAccordionInner) => (
                    <Box style={{textAlign: "center"}}>{index + 1}</Box>
                ),
            },
            {
                Header: "Valor",
                accessor: "valor",
                Cell: ({ row: { original } }: CellItemAccordionInner) => (
                    <Box>R$ {formatCurrency(original.valor ? original.valor : 0)}</Box>
                ),
            },
            {
                Header: "Vencimento",
                accessor: "vencimento",
                Cell: ({ row: { original } }: CellItemAccordionInner) => (
                    <Box>{moment(original.dataVencimento).format("DD/MM/YYYY")}</Box>
                ),
            },
            {
                Header: "Pagamento",
                accessor: "pagamento",
                Cell: ({ row: { original } }: CellItemAccordionInner) => (
                    <Box>R$ {formatCurrency(original.valorPago ? original.valorPago : 0)}</Box>
                ),
            }
        ];
    }, []);
}
